import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { Box } from '../../foundation/Box/index.js';
import { Container, IconContainer, ContentContainer, StyledTitle, StyledMessage } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function Alert(props) {
  var appearance = props.appearance,
    title = props.title,
    message = props.message,
    children = props.children,
    rest = __rest(props, ["appearance", "title", "message", "children"]);
  var iconMap = {
    success: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      $size: 18,
      icon: faCircleCheck
    }),
    info: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      $size: 18,
      icon: faInfoCircle
    }),
    warning: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      $size: 18,
      icon: faExclamationTriangle
    }),
    danger: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      $size: 18,
      icon: faCircleXmark
    })
  };
  return /*#__PURE__*/jsxs(Container, _extends({
    role: "alert",
    $onlyMessage: !title && !children
  }, rest, {
    children: [/*#__PURE__*/jsx(IconContainer, {
      $appearance: appearance,
      children: iconMap[appearance]
    }), /*#__PURE__*/jsxs(ContentContainer, {
      children: [title && /*#__PURE__*/jsx(StyledTitle, {
        $fontWeight: "semibold",
        $fontSize: "small",
        $appearance: "200",
        children: title
      }), /*#__PURE__*/jsx(StyledMessage, {
        $fontWeight: "regular",
        $fontSize: "small",
        $appearance: "100",
        children: message
      }), children && /*#__PURE__*/jsx(Box, {
        flexDirection: "row",
        gap: "md",
        mt: "md",
        children: children
      })]
    })]
  }));
}

export { Alert };
